import React from 'react';
import ServicePage from './ServicePage';
import { IconClipboard, IconUserCheck, IconShield } from '../../components/Icons';

const DATA = {
  icon: <IconClipboard size={32} />, category: 'mineria',
  title: 'PTO – Plan de Trabajos y Obras',
  subtitle: 'Elaboración del PTO conforme a los requisitos de la Agencia Nacional Minera (ANM).',
  norm: 'Ley 685 de 2001 – Código de Minas',
  desc: 'Elaboramos el Plan de Trabajos y Obras (PTO) conforme a los requisitos técnicos y normativos exigidos por la ANM para la legalización y ejecución de contratos de concesión minera, asegurando su viabilidad técnica y legal.',
  details: [
    'Estudio de títulos y caracterización del área',
    'Diseño del método de explotación',
    'Programación de producción y vida de la mina',
    'Plan de inversiones, equipos y costos',
    'Medidas de seguridad e higiene minera',
    'Presentación y seguimiento ante la ANM',
  ],
  related: [
    { icon: <IconUserCheck size={18} />, label: 'Asesorías Mineras', path: '/servicios/asesorias-mineras' },
    { icon: <IconShield size={18} />,    label: 'Sostenimiento',     path: '/servicios/sostenimiento' },
  ],
};

export default function PTO() { return <ServicePage data={DATA} />; }
